export const translations = {
  loginPage: {
    proceedLogin: {
      'en-150': 'Proceed',
      'sk-SK': 'Pokračovať'
    },
    usernameLabel: {
      'en-150': 'Username',
      'sk-SK': 'Používateľ'
    },
    passwordLabel: {
      'en-150': 'Password',
      'sk-SK': 'Heslo'
    },
    invalidPassword: {
      'en-150': 'Invalid password',
      'sk-SK': 'Nesprávne heslo'
    },
    invalidUsername: {
      'en-150': 'Invalid username',
      'sk-SK': 'Používateľ neexistuje'
    },
    usernameExpired: {
      'en-150': 'Account expired',
      'sk-SK': 'Platnosť účtu vypršala'
    },
    sessionExpired: {
      'en-150': 'You were logged out, your session has expired',
      'sk-SK': 'Boli ste odhlásený, platnosť prihlásenia vypršala'
    },
    calendariumLabel: {
      'en-150': 'Calendarium',
      'sk-SK': 'Kalendárium'
    },
    oldVersionLabel: {
      'en-150': 'Proceed with the old version',
      'sk-SK': 'Prejsť na starú verziu'
    }
  }
}
